//Sarada : 10-10-2022
import { FAQs_GET_LIST,FAQs_GET_LIST_SUCCESS,FAQs_GET_LIST_ERROR } from "../../../redux/contants";

import { all, fork, put, takeEvery } from 'redux-saga/effects';
import axios from 'axios'
import { apiBaseUrl } from '../../../constants/defaultValues';


function* fetchfaqsAPI() {
    // alert('saga')
    try {
        // const subscriberDetails = yield Axios.get(`Role/GetRoleList`).then(response => response.data);
        // alert("c")
          const config = {
            method: 'get',
            url: `${apiBaseUrl}FAQS/GetFAQSList`,
            headers: { 
              'Accept': 'text/plain', 
              'Authorization': '<API Key>'
            }
          };
          const faqsdetails = yield axios(config).then(response => response.data.Data);
        
        // console.log(subscriberDetails,"============")
        yield put({ type: FAQs_GET_LIST_SUCCESS, data: faqsdetails });
    } catch (error) {
        yield put({ type: FAQs_GET_LIST_ERROR, error });
    }
}


export function* watchfaqs() {
    // eslint-disable-next-line no-use-before-define
    yield takeEvery(FAQs_GET_LIST, fetchfaqsAPI);

}

export default function* rootSaga() {
    yield all([
        fork(watchfaqs),
    ]);
}